// ----------------------------------------------------------------------
// <copyright file="Izenda.LeftContentActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var withHandlers = require('recompose').withHandlers;
  var { curry } = require('lodash/fp');

  var leftContentActions = withHandlers({
    updateResults: curry(updateResults)
  });

  /**
   * update results for Fields/Formats tab
   */
  function updateResults(props, _) {
    var loader = props.loader;
    var fieldsStore = props.store;
    var fieldsModel = fieldsStore.model;

    loader.startLoading();
    return fieldsStore
      .updateReportsParts()
      .then(fieldsModel.cleanDirty.bind(fieldsModel))
      .finally(loader.endLoading.bind(loader));
  }

  module.exports = leftContentActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Izenda.LeftContentActions.js